<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.goodsTitle-container-start -->
    <!-- <goods-title></goods-title> -->
    <tabbar :tabbarIndex="1"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>

    <!-- 2.goodsTitle-container-end -->

    <!-- 3. -container-start -->
    <div class="main">
      <div class="center borderShadow">
        <div class="top twoLine">
          {{ currentPageInfo.notice_title || "暂无标题" }}
        </div>
        <div
          class="bottom"
          v-html="currentPageInfo.notice_info"
          v-if="currentPageInfo.notice_info"
        ></div>
        <div class="bottom" v-else>暂无公告内容</div>
        <div @click="goBack" class="goback c-animation hands">返回</div>
      </div>
    </div>
    <!-- 3.main-container-end -->

    <!-- 4.goodsFooter-container-start -->
    <!-- <goods-footer class="footer"></goods-footer> -->
    <c-footer></c-footer>
    <!-- 4.goodsFooter-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import {
  TCInterGGDetailRequest,
  cardInterGGDetailRequest,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      currentPageInfo: {}, // 1.1.currentPageInfo
      token: "", // 1.2.token
      sysId: "", // 1.3.sysId
      noticeId: "", // 1.4.公告id
    };
  },

  components: {
    // 2.components
    // goodsTitle,
    // goodsFooter
    tabbar,
    cFooter: footer,
  },

  methods: {
    // 3.methods
    getGGDetauk() {
      // 3.1.获取公告详情信息
      let data = {
        noticeId: this.noticeId,
        sysId: this.sysId,
      };

      if (this.type == 1) {
        TCInterGGDetailRequest(data).then((res) => {
          if (res) {
            this.currentPageInfo = res.data[0];
          }
        });
      } else {
        cardInterGGDetailRequest(data).then((res) => {
          if (res) {
            this.currentPageInfo = res.data[0];
          }
        });
      }
    },

    goBack() {
      // 3.2.返回
      this.$router.go(-1);
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },

  mounted() {
    // 4.mounted
    this.sysId = localStorage.sysId || "";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";

    let res = JSON.parse(decodeURIComponent(this.$route.query.obj));
    this.type = this.$route.query.type || 0;
    this.token = res.token;
    this.noticeId = res.noticeId;
    this.getGGDetauk();
  },
};
</script>

<style scoped lang="scss">
@import "./ggDetail.scss";
</style>